export enum TemplateCoordonneesBancaireEnum {
  AFFICHER_COORDONNEES_BANCAIRE,
  ERREUR_NON_DISPONIBLE_MEMBRE,
  ERREUR_NON_DISPONIBLE,
}
export default TemplateCoordonneesBancaireEnum;
